import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  CardMedia,
  Avatar,
  Divider,
  IconButton,
  InputAdornment,
  Tooltip,
  DialogContentText, 
} from "@mui/material";
import {
  Search as SearchIcon,
  Edit as EditIcon,
  CheckCircle as ApproveIcon,
  Cancel as RejectIcon,
  Person as UserIcon,
  Visibility as ViewIcon,
  PhotoCamera as MediaIcon,
  CloudUpload as UploadIcon,
} from "@mui/icons-material";
import axios from "axios";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import CircularProgress from '@mui/material/CircularProgress';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const PostReviewPanel = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [editData, setEditData] = useState({});
  const [newMedia, setNewMedia] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openSessionDialog, setOpenSessionDialog] = useState(false);
  const [editSession, setEditSession] = useState(null);
  const [editSessionData, setEditSessionData] = useState({});
  const [openUserDialog, setOpenUserDialog] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [expertDetails, setExpertDetails] = useState(null);
  const [openMediaDialog, setOpenMediaDialog] = useState(false);
  const [mediaUrl, setMediaUrl] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [newSessionMedia, setNewSessionMedia] = useState(null);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [actionType, setActionType] = React.useState(null); // "approve" or "reject"
  const [selectedId, setSelectedId] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingSeconds, setLoadingSeconds] = useState(0);


  useEffect(() => {
          let timer;
        
          if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
              setLoadingSeconds(prev => prev + 1);
            }, 1000);
          } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
          }
        
          return () => clearInterval(timer); // cleanup on unmount or loading = false
        }, [loading]);


  const openConfirm = (type, id) => {
    setActionType(type);
    setSelectedId(id);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
    setActionType(null);
    setSelectedId(null);
  };

  const handleConfirm = () => {
    if (actionType === "approve") {
      handleApprove(selectedId);
    } else if (actionType === "reject") {
      handleReject(selectedId);
    }
    closeConfirm();
  };


  // -------------------------------
  // Helper Functions
  // -------------------------------
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  // const getMediaTypeFromFile = (file) => {
  //   const ext = file.name.split(".").pop().toLowerCase();
  //   const imageExts = ["jpg", "jpeg", "png", "gif", "bmp"];
  //   const videoExts = ["mp4", "mov", "avi", "mkv"];

  //   if (imageExts.includes(ext)) return "image";
  //   if (videoExts.includes(ext)) return "video";
  //   return "unknown";
  // };


  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "video/mp4",
  "video/webm",
  "video/quicktime",
];

const validateFile = (file) => {
  if (!file) return "No file selected";

  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Only images and videos are allowed";
  }

  if (file.size > MAX_FILE_SIZE) {
    return "File size must be less than 5 MB";
  }

  return null;
};

const getMediaTypeFromFile = (file) => {
  if (!file || !file.type) return null;
  if (file.type.startsWith("image/")) return "image";
  if (file.type.startsWith("video/")) return "video";
  return "unknown";
};

const getPresignedUrl = async (file) => {
  const res = await axios.post(`${API_URL}/api/presigned-url/`, {
    file_name: file.name,
    file_type: file.type,
    file_size: file.size,
  });

  return res.data; // { upload_url, key }
};

const uploadToS3 = async (file) => {
  const error = validateFile(file);
  if (error) throw new Error(error);

  const { upload_url, key } = await getPresignedUrl(file);

  await axios.put(upload_url, file, {
    headers: {
      "Content-Type": file.type,
    },
  });

  return key;
};

  

  // const uploadToS3 = async (file) => {
  //       if (!file) return null;
    
  //       const formData = new FormData();
  //       formData.append("file", file);
    
  //       const uploadRes = await axios.post(`${API_URL}/api/upload-s3/`, formData, {
  //         headers: { "Content-Type": "multipart/form-data" },
  //       });
  //       return uploadRes.data.key;
  //     };

  // -------------------------------
  // Lifecycle & API
  // -------------------------------
  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/posts/under_review/`);
      setPosts(res.data);
      setFilteredPosts(res.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }
  };

  useEffect(() => {
    const q = searchQuery.toLowerCase();
    setFilteredPosts(
      posts.filter(
        (p) =>
          (p.title && p.title.toLowerCase().includes(q)) ||
          (p.description && p.description.toLowerCase().includes(q))
      )
    );
  }, [searchQuery, posts]);

  // -------------------------------
  // Actions
  // -------------------------------


  const handleApprove = async (id) => {
  setLoading(true);

  try {
    await axios.post(`${API_URL}/posts/approve/`, { id });
    fetchPosts();
  } catch (error) {
    console.error("Error approving post:", error);
  } finally {
    setLoading(false); // your useEffect will stop the timer here
  }
};


  const handleReject = async (id) => {
  setLoading(true);

  try {
    await axios.post(`${API_URL}/posts/reject/`, { id });
    fetchPosts();
  } catch (error) {
    console.error("Error rejecting post:", error);
  } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }
};


  const handleEditOpen = (post) => {
    setSelectedPost(post);
    setEditData(post);
    setNewMedia(null);
    setOpenEditDialog(true);
  };

  // const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

  const handleMediaChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  if (!ALLOWED_TYPES.includes(file.type)) {
    alert("Only images and videos are allowed");
    e.target.value = "";
    return;
  }

  if (file.size > MAX_FILE_SIZE) {
    alert("File size must be less than 5 MB");
    e.target.value = "";
    return;
  }

  setNewMedia(file);
};


// const handleMediaChange = (e) => {
//   const file = e.target.files?.[0];
//   if (!file) return;

//   if (file.size > MAX_FILE_SIZE) {
//     alert('File size must be less than 5 MB');
//     e.target.value = ''; // reset input
//     return;
//   }

//   setNewMedia(file);
// };


  // const handleMediaChange = (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     setNewMedia(e.target.files[0]);
  //   }
  // };

  const handleEditSave = async () => {
    setLoading(true);
    try {
      let media_key = editData.media_key;
      if (newMedia) {
        // media_url = await handleUploadToCloudinary(newMedia);
        console.log("Uploading:", {
  name: newMedia.name,
  type: newMedia.type,
  size: newMedia.size,
  isFile: newMedia instanceof File,
});

        
        media_key = await uploadToS3(newMedia);
      }

      await axios.put(`${API_URL}/posts/edit/`, {
        ...editData,
        media_key,
      });

      setOpenEditDialog(false);
      fetchPosts();
    } catch (error) {
      console.error("Error editing post:", error);
    } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }
  };

  // -------------------------------
  // Sessions
  // -------------------------------
  const handleViewSessions = async (post) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/posts/sessions/`, { id: post.id });
      setSessions(res.data);
      setOpenSessionDialog(true);
    } catch (error) {
      console.error("Error fetching sessions:", error);
    } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }

  };



  const handleSessionEditOpen = (session) => {
    setEditSession(session);
    setEditSessionData(session);
    setNewSessionMedia(null);
  };


  const handleSessionEditSave = async () => {
    setLoading(true);
    try {
      let media_key = editSessionData.media_key || null;

      // Upload new media to Cloudinary if selected
      if (newSessionMedia) {
        // media_url = await handleUploadToCloudinary(newSessionMedia);
        media_key = await uploadToS3(newSessionMedia);
      }

      // Prepare session data
      const updatedSession = {
        ...editSessionData,
        media_key,
      };

      // Send updated session to backend
      await axios.put(`${API_URL}/post-bundles/edit/`, updatedSession);

      // Reset edit state
      setEditSession(null);
      setNewSessionMedia(null);

      // Refresh sessions for the selected post
      handleViewSessions(selectedPost);
    } catch (error) {
      console.error("Error editing session:", error);
    } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }
  };



  // -------------------------------
  // User & Media
  // -------------------------------
  const handleViewUser = async (user_id) => {
    setLoading(true);
    try {
      // Fetch both in parallel — GET for user, POST for expert
      const [userRes, expertRes] = await Promise.all([
        axios.get(`${API_URL}/get_user_data/`, { params: { user_id } }),
        axios.post(`${API_URL}/api/experts/check/`, { user_id }), // <-- POST
      ]);

      setUserDetails(userRes.data || null);
      setExpertDetails(expertRes.data || null);
      setOpenUserDialog(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
      setUserDetails(null);
      setExpertDetails(null);
    } finally {
    setLoading(false); // your useEffect will stop/reset the timer
  }
  };


  // const handleViewMedia = (key) => {
  //   setMediaUrl(url);
  //   setOpenMediaDialog(true);
  // };

  const handleViewMedia = async (key) => {
  try {
    setLoading(true);

    const res = await axios.get(`${API_URL}/posts/media-url/`, {
      params: { key },
    });

    setMediaUrl(res.data.url);  // presigned url
    setOpenMediaDialog(true);

  } catch (error) {
    console.error("Error getting media:", error);
  } finally {
    setLoading(false);
  }
};

// const getPresignedUrl = async (key) => {
//   try {
//     const res = await axios.get(`${API_URL}/posts/media-url/`, {
//       params: { key },
//     });
//     return res.data.url;
//   } catch (error) {
//     console.error("Failed to fetch presigned URL:", error);
//     return null;
//   }
// };






  // -------------------------------
  // UI
  // -------------------------------
  return (
    <div>
      <Header1 />
      <Box p={4} sx={{ backgroundColor: "#000000", minHeight: "100vh" }}>
        <Typography variant="h4" component="h1" sx={{
          marginBottom: '1.5rem',
          marginTop: '1.5rem',
          textAlign: 'center',
          letterSpacing: 5,
          color: 'transparent', // Make the text color transparent so that gradient can be applied
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)', // Apply the gradient
          backgroundClip: 'text', // Clip the background to the text
          WebkitBackgroundClip: 'text', // For Safari browser support

        }}>
          Post Review Dashboard
        </Typography>

        <TextField
          placeholder="Search posts..."
          variant="outlined"
          fullWidth
          margin="normal"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />

        <Box mt={1} display="flex" flexWrap="wrap" gap={3} justifyContent="center">
  {filteredPosts.length === 0 ? (
    <Typography
      variant="h6"
      color="text.secondary"
      textAlign="center"
      sx={{ width: "100%", mt: 4 }}
    >
      No posts found.
    </Typography>
  ) : (
    filteredPosts.map((post) => (
      <Box
        key={post.id}
        flex="1 1 calc(33.333% - 16px)" // 3 per row on large screens
        minWidth="250px" // responsive minimum width
      >
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 4,
            position:"relative",
            transition: "transform 0.2s",
            "&:hover": { transform: "translateY(-5px)" },
          }}
        >
                      <Box
  sx={{
    position: "absolute",
    top: 10,
    right: 10,
    px: 1.5,
    py: 0.5,
    borderRadius: 2,
    fontSize: "0.7rem",
    fontWeight: 600,
    color: "#fff",
    background:
      post.type === "ai_immersion"
        ? "linear-gradient(135deg, #7c6cff, #ffb547)"   // purple → orange
        : "linear-gradient(135deg, #1e90ff, #0066cc)"  // bl
  }}
>
  {post.type === "ai_immersion" ? "AI IMMERSION" : "SESSION"}
</Box>
          <CardContent>
            <Typography variant="h6" fontWeight="600">
              {post.title || "Untitled"}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 1,
                minHeight: "60px",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {post.description || "No description provided."}
            </Typography>

            <Typography
              variant="caption"
              sx={{
                display: "block",
                color:
                  post.status === "approved"
                    ? "green"
                    : post.status === "rejected"
                    ? "red"
                    : "gray",
                mt: 1,
              }}
            >
              Status: {post.status}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Tooltip title="Approve">
                <IconButton
                  color="success"
                  onClick={() => openConfirm("approve", post.id)}
                >
                  <ApproveIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Reject">
                <IconButton
                  color="error"
                  onClick={() => openConfirm("reject", post.id)}
                >
                  <RejectIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Edit Post">
                <IconButton
                  color="primary"
                  onClick={() => handleEditOpen(post)}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>

              {post.media_key && (
                <Tooltip title="View Media">
                  <IconButton
                    color="secondary"
                    onClick={() => handleViewMedia(post.media_key)}
                  >
                    <MediaIcon />
                  </IconButton>
                </Tooltip>
              )}

              {post.is_bundle && (
                <Tooltip title="View Sessions">
                  <IconButton
                    color="info"
                    onClick={() => handleViewSessions(post)}
                  >
                    <ViewIcon />
                  </IconButton>
                </Tooltip>
              )}

              {post.user_id && (
                <Tooltip title="View User">
                  <IconButton
                    color="primary"
                    onClick={() => handleViewUser(post.user_id)}
                  >
                    <UserIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    ))
  )}
</Box>


        {/* Edit Post Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={() => setOpenEditDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Edit Post</DialogTitle>
          <DialogContent>
            {Object.keys(editData)
              .filter(
                (key) => key !== "id" && key !== "user_id" && key !== "media_url"
              )
              .map((key) =>
                typeof editData[key] === "string" ||
                  typeof editData[key] === "number" ? (
                  <TextField
                    key={key}
                    label={key}
                    fullWidth
                    margin="dense"
                    value={editData[key] || ""}
                    onChange={(e) =>
                      setEditData({ ...editData, [key]: e.target.value })
                    }
                  />
                ) : null
              )}

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1" gutterBottom>
              Media
            </Typography>

          {newMedia ? (
  <Box textAlign="center">
    {getMediaTypeFromFile(newMedia) === "video" ? (
      <video src={URL.createObjectURL(newMedia)} controls style={{ width: "100%", borderRadius: "8px" }} />
    ) : (
      <img src={URL.createObjectURL(newMedia)} alt="New Upload" style={{ width: "100%", borderRadius: "8px" }} />
    )}
  </Box>
) : mediaUrl ? (
  <Box textAlign="center">
    {mediaUrl.match(/\.(mp4|webm|ogg)$/) ? (
      <video src={mediaUrl} controls style={{ width: "100%", borderRadius: "8px" }} />
    ) : (
      <img src={mediaUrl} alt="Current Media" style={{ width: "100%", borderRadius: "8px" }} />
    )}
  </Box>
) : (
  <Typography color="text.secondary">No media uploaded.</Typography>
)}



            {/* <Button
              component="label"
              variant="outlined"
              startIcon={<UploadIcon />}
              sx={{ mt: 2 }}
            >
              Change Media
              <input
                type="file"
                hidden
                accept="image/*,video/*"
                onChange={handleMediaChange}
              />
            </Button> */}

            <Button
  component="label"
  variant="outlined"
  startIcon={<UploadIcon />}
  sx={{ mt: 2 }}
>
  Change Media
  <Typography variant="caption" sx={{ ml: 1 }}>
    (Max 5 MB)
  </Typography>

  <input
    type="file"
    hidden
    accept="image/*,video/*"
    onChange={handleMediaChange}
  />
</Button>

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
            <Button onClick={handleEditSave} variant="contained">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* Sessions Dialog */}
        <Dialog
          open={openSessionDialog}
          onClose={() => setOpenSessionDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center" }}>
            Sessions for "{selectedPost?.title}"
          </DialogTitle>

          <DialogContent>
            {sessions.length === 0 ? (
              <Typography>No sessions available.</Typography>
            ) : (
              sessions.map((session) => (
                <Card key={session.id} sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {session.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {session.description}
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleSessionEditOpen(session)}
                      >
                        Edit Session
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              ))
            )}

            {/* Edit Section (similar to Edit Post Dialog) */}
            {editSession && (
              <Box sx={{ mt: 3 }}>
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
                >
                  Edit Session
                </Typography>

                {/* Dynamically generate all editable fields except restricted ones */}
                {Object.keys(editSessionData)
                  .filter(
                    (key) =>
                      key !== "id" &&
                      key !== "post_id" &&
                      key !== "media_url" &&
                      key !== "created_at" &&
                      key !== "updated_at"
                  )
                  .map((key) =>
                    typeof editSessionData[key] === "string" ||
                      typeof editSessionData[key] === "number" ? (
                      <TextField
                        key={key}
                        label={key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                        fullWidth
                        margin="dense"
                        value={editSessionData[key] || ""}
                        onChange={(e) =>
                          setEditSessionData({
                            ...editSessionData,
                            [key]: e.target.value,
                          })
                        }
                      />
                    ) : null
                  )}

                <Divider sx={{ my: 2 }} />

                {/* Media Section (same layout as Post Dialog) */}
                <Typography variant="subtitle1" gutterBottom>
                  Media
                </Typography>

                {newSessionMedia ? (
                  <Box textAlign="center">
                    {/\.(mp4|webm|ogg)$/i.test(newSessionMedia.name) ? (
                      <video
                        src={URL.createObjectURL(newSessionMedia)}
                        controls
                        style={{ width: "100%", borderRadius: "8px" }}
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(newSessionMedia)}
                        alt="New Upload"
                        style={{ width: "100%", borderRadius: "8px" }}
                      />
                    )}
                  </Box>
                ) : editSessionData.media_url ? (
                  <Box textAlign="center">
                    {editSessionData.media_url.match(/\.(mp4|webm|ogg)$/i) ? (
                      <video
                        src={editSessionData.media_url}
                        controls
                        style={{ width: "100%", borderRadius: "8px" }}
                      />
                    ) : (
                      <img
                        src={editSessionData.media_url}
                        alt="Current Media"
                        style={{ width: "100%", borderRadius: "8px" }}
                      />
                    )}
                  </Box>
                ) : (
                  <Typography color="text.secondary">No media uploaded.</Typography>
                )}

                {/* <Button
                  component="label"
                  variant="outlined"
                  startIcon={<UploadIcon />}
                  sx={{ mt: 2 }}
                >
                  Change Media
                  <input
                    type="file"
                    hidden
                    accept="image/*,video/*"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        setNewSessionMedia(e.target.files[0]);
                      }
                    }}
                  />
                </Button> */}

                <Button
  component="label"
  variant="outlined"
  startIcon={<UploadIcon />}
  sx={{ mt: 2 }}
>
  Change Media
  <Typography variant="caption" sx={{ ml: 1 }}>
    (Max 5 MB)
  </Typography>

  <input
    type="file"
    hidden
    accept="image/*,video/*"
    onChange={(e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

      if (file.size > MAX_FILE_SIZE) {
        alert('File size must be less than 5 MB');
        e.target.value = '';
        return;
      }

      setNewSessionMedia(file);
    }}
  />
</Button>


                <Box sx={{ mt: 3, textAlign: "center" }}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleSessionEditSave}
                  >
                    Save Session
                  </Button>
                </Box>
              </Box>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenSessionDialog(false)}>Close</Button>
          </DialogActions>
        </Dialog>


        {/* Media Viewer Dialog */}
        <Dialog
          open={openMediaDialog}
          onClose={() => setOpenMediaDialog(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Media Viewer</DialogTitle>
          <DialogContent>
            {mediaUrl && mediaUrl.includes("mp4") ? (
    <video
      src={mediaUrl}
      controls
      style={{ width: "100%", borderRadius: "8px" }}
    />
) : (
    <img
      src={mediaUrl}
      alt="Post Media"
      style={{ width: "100%", borderRadius: "8px" }}
    />
)}

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenMediaDialog(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* User Details Dialog */}
        <Dialog
          open={openUserDialog}
          onClose={() => setOpenUserDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center" }}>Expert Details</DialogTitle>
          <DialogContent>
            {userDetails ? (
              <Box textAlign="center" p={2}>
                {userDetails.image && (
                  <Avatar
                    src={userDetails.image}
                    alt={userDetails.name}
                    sx={{ width: 100, height: 100, margin: "auto" }}
                  />
                )}

                <Typography variant="h6" mt={2}>
                  {`${userDetails.name ?? ""} ${userDetails.surname ?? ""}`.trim()}
                </Typography>

                <Typography variant="body2">{userDetails.email}</Typography>
                <Typography variant="body2">{userDetails.contact}</Typography>

                {/* Expert Details Section */}
                {expertDetails && (
                  <Box mt={3} textAlign="left">
                    {expertDetails.designation && (
                      <Typography variant="subtitle1" fontWeight="bold">
                        Designation:
                      </Typography>
                    )}
                    <Typography variant="body2" mb={1}>
                      {expertDetails.designation || "N/A"}
                    </Typography>

                    {expertDetails.areas_of_expertise && (
                      <Typography variant="subtitle1" fontWeight="bold">
                        Areas of Expertise:
                      </Typography>
                    )}
                    <Typography variant="body2" mb={1}>
                      {expertDetails.areas_of_expertise || "N/A"}
                    </Typography>

                    {expertDetails.about && (
                      <Typography variant="subtitle1" fontWeight="bold">
                        About:
                      </Typography>
                    )}
                    <Typography variant="body2">
                      {expertDetails.about || "N/A"}
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <Typography>Loading user details...</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenUserDialog(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={confirmOpen} onClose={closeConfirm}>
          <DialogTitle>
            {actionType === "approve" ? "Confirm Approval" : "Confirm Rejection"}
          </DialogTitle>

          <DialogContent>
            <DialogContentText>
              Are you sure you want to {actionType} this post?
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={closeConfirm}>Cancel</Button>
            <Button
              variant="contained"
              color={actionType === "approve" ? "success" : "error"}
              onClick={handleConfirm}
            >
              {actionType === "approve" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        {loading && (
                                      <Box
                                        sx={{
                                          position: 'fixed',
                                          top: 0,
                                          left: 0,
                                          width: '100vw',
                                          height: '100vh',
                                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                          zIndex: 2000,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          backdropFilter: 'blur(3px)',
                                        }}
                                      >
                                        <Box sx={{ textAlign: 'center' }}>
                                          <CircularProgress
                              size={60}
                              thickness={6}
                              sx={{
                                color: 'transparent',
                                '& .MuiCircularProgress-circle': {
                                  stroke: 'url(#better-gradient)',
                                },
                              }}
                            />
                            
                            <svg width="0" height="0">
                              <defs>
                                <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                                  <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                                  <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                                </linearGradient>
                              </defs>
                            </svg>
                            
                                          <Typography
                                            variant="h6"
                                            sx={{
                                              mt: 2,
                                              color: '#fff',
                                              textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                                            }}
                                          >
                                            Loading Details... ({loadingSeconds} sec)
                                          </Typography>
                                        </Box>
                                      </Box>
                                    )}



      </Box>
      <Footer2 />
    </div>
  );
};

export default PostReviewPanel;
